export default __webpack_public_path__ + "static/media/Espronceda logo square.def7e223.jpeg";